export function calculatePropose(current: number, propose: number) {
  if (!propose || propose === 0) return 0;
  const difference = propose - current;
  const divi = difference / current;
  return isFinite(divi) ? divi * 100 : 0;
}